import type { ReactNode } from 'react'
import type { Viewer } from '@/types'

import { createContext, useContext } from 'react'

interface SiteContextValue {
    viewer: Viewer | null
    origin: string
    now: string
}

const SiteContext = createContext<SiteContextValue>({
    viewer: null,
    origin: '',
    now: ''
})

interface SiteProviderProps {
    value: SiteContextValue
    children: ReactNode
}

export const SiteProvider = ({ value, children }: SiteProviderProps) => (
    <SiteContext.Provider value={value}>
        {children}
    </SiteContext.Provider>
)

export const useSite = () => useContext(SiteContext)
